import _ from 'lodash';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContextualHelpModal from '../../../components/ContextualHelpModal';

import { ReactComponent as InfoSvg } from '../../../assets/info-black.svg';
import styles from './index.module.css';
import classNames from 'classnames';

export enum InstructionType {
  Directions = 'directions',
  Instructions = 'instructions',
}

interface Props {
  instructionType: InstructionType;
  patientInstruction?: string | null;
  covidInstruction?: string | null;
  characterLimit?: number;
}

export const InstructionView: React.FC<Props> = ({
  instructionType,
  patientInstruction,
  covidInstruction,
  characterLimit = 110,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  if (!patientInstruction && !covidInstruction) return null;
  const concatInstructions = _.compact([
    patientInstruction,
    covidInstruction,
  ]).join('\n\n');
  const limitedInstructions =
    concatInstructions.slice(0, characterLimit) + '...';
  return (
    <>
      <div className={styles.AppointmentDetailRow}>
        <InfoSvg className={classNames(styles.IconItem, styles.InfoIcon)} />
        <span
          className={classNames(
            styles.InstructionLabel,
            styles.AppointmentDetailContent,
          )}
        >
          {t(instructionType)}:&nbsp;
          <span className={styles.Instruction}>
            {limitedInstructions}&nbsp;
            <span
              className={styles.ReadMore}
              onClick={() => {
                setIsModalOpen(!isModalOpen);
              }}
            >
              {t('readMore')}
            </span>
          </span>
        </span>
      </div>
      <ContextualHelpModal
        headerText={t(`visitType`, { type: t(instructionType).toLowerCase() })}
        helpText={concatInstructions}
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        onHandleHelpful={async () => setIsModalOpen(false)}
      />
    </>
  );
};
